/* FABEL — predictive-search.js : overlay search with Shopify predictive results. */
(function () {
  'use strict';
  const FABEL = window.FABEL;

  class SearchModal extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.form = this.querySelector('form');
      this.abort = null;
      this.releaseFocus = null;
      this.cache = {};

      this.onKeydown = (event) => {
        if (event.key === 'Escape') this.close();
      };

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-search-close]')) {
          event.preventDefault();
          this.close();
        }
      });

      if (this.input && this.dataset.predictive === 'true') {
        this.input.addEventListener(
          'input',
          FABEL.debounce(() => this.search(), 220)
        );
      }
    }

    open(opener) {
      this.setAttribute('data-open', 'true');
      this.removeAttribute('aria-hidden');
      FABEL.showOverlay();
      FABEL.lockScroll();
      document.addEventListener('keydown', this.onKeydown);
      this.releaseFocus = FABEL.trapFocus(this, opener);
    }

    close() {
      if (this.getAttribute('data-open') !== 'true') return;
      this.removeAttribute('data-open');
      this.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', this.onKeydown);
      FABEL.unlockScroll();
      if (!document.querySelector('fabel-drawer[data-open="true"]')) FABEL.hideOverlay();
      if (this.releaseFocus) this.releaseFocus();
    }

    search() {
      const term = this.input.value.trim();
      if (!this.results) return;

      if (term.length < 2) {
        this.results.innerHTML = this.defaultContent || '';
        return;
      }
      if (this.defaultContent === undefined) this.defaultContent = this.results.innerHTML;

      if (this.cache[term]) {
        this.results.innerHTML = this.cache[term];
        return;
      }

      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      this.results.classList.add('facets-loading');

      const types = ['product'];
      if (this.dataset.collections === 'true') types.push('collection');
      if (this.dataset.pages === 'true') types.push('page');

      const url = `${FABEL.routes.predictive_search_url}?q=${encodeURIComponent(term)}&resources[type]=${types.join(
        ','
      )}&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;

      fetch(url, { signal: this.abort.signal })
        .then((response) => response.text())
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const markup = parsed.querySelector('[data-predictive-results]');
          const html = markup ? markup.innerHTML : '';
          this.cache[term] = html;
          this.results.innerHTML = html;
          this.results.classList.remove('facets-loading');
          const count = this.results.querySelectorAll('[data-result-item]').length;
          FABEL.announce(FABEL.strings.searchResults.replace('[count]', count));
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          this.results.classList.remove('facets-loading');
        });
    }
  }
  if (!customElements.get('search-modal')) customElements.define('search-modal', SearchModal);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-search-toggle]');
    if (!trigger) return;
    const modal = document.getElementById('search-modal');
    if (modal && typeof modal.open === 'function') {
      event.preventDefault();
      modal.open(trigger);
    }
  });
})();
